import * as React from 'react'

const SvgAudioTranscription = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 8.75v-2.5a.625.625 0 01.181-.444l4.375-4.375A.625.625 0 017.5 1.25h6.25c.69 0 1.25.56 1.25 1.25v15c0 .69-.56 1.25-1.25 1.25h-10c-.69 0-1.25-.56-1.25-1.25v-1.25h1.25v1.25h10v-15h-5v3.75c0 .69-.56 1.25-1.25 1.25H3.75v1.25H2.5zm5-2.5V2.756L4.006 6.25H7.5z"
      fill="#163250"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.163 11.193l-.314.253a1.903 1.903 0 01-.06 2.6l.303.275a2.283 2.283 0 00.071-3.12v-.008zm-1.145.77c.4.455.385 1.124-.037 1.56l.302.268a1.522 1.522 0 00.047-2.081l-.312.253zM5.284 15.5a.21.21 0 01-.146-.059l-1.564-1.513H2.205A.201.201 0 012 13.732v-1.965c0-.109.092-.197.205-.197h1.369l1.564-1.513a.212.212 0 01.29 0c.038.036.06.086.06.138v5.108a.201.201 0 01-.204.197zM13.286 11.786v-.715H11.5v-.714h-.714v.714H9v.715h2.934a3.068 3.068 0 01-.791 1.42 3.314 3.314 0 01-.517-.706h-.793c.182.436.441.835.766 1.178-.383.272-.8.492-1.242.653l.25.669c.55-.2 1.067-.481 1.533-.834.468.353.987.634 1.538.834l.25-.669a5.24 5.24 0 01-1.241-.652c.504-.522.843-1.18.974-1.893h.625zm-1.012-2.857h.774L11.41 5h-.774L9 8.929h.774l.297-.715h1.905l.298.715zM10.369 7.5l.655-1.571.655 1.571h-1.31z"
      fill="#163250"
    />
  </svg>
)

export default SvgAudioTranscription
